import moment from 'moment-timezone';
import { Entities, Periods } from 'cio/utils/metrics/common';

export class TrackedResponseMetricStat {
  totals: Record<string, number>;
  trackedResponses: Record<string, number[]>;

  constructor(totals: Record<string, number>, trackedResponses: Record<string, number[]>) {
    this.totals = totals;
    this.trackedResponses = trackedResponses;
  }

  get totalResponses(): number {
    return Object.values(this.totals).reduce((a, b) => a + b, 0);
  }

  addMetric(otherMetric: TrackedResponseMetricStat): void {
    for (let key in otherMetric.totals) {
      if (key in this.totals) {
        this.totals[key] += otherMetric.totals[key];
      } else {
        this.totals[key] = otherMetric.totals[key];
      }
    }

    for (let key in otherMetric.trackedResponses) {
      if (key in this.trackedResponses) {
        this.trackedResponses[key] = this.addArraysElementWise(
          this.trackedResponses[key],
          otherMetric.trackedResponses[key],
        );
      } else {
        this.trackedResponses[key] = [...otherMetric.trackedResponses[key]];
      }
    }
  }

  private addArraysElementWise(a: number[], b: number[]): number[] {
    let result: number[] = [];
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      result[i] = (a[i] || 0) + (b[i] || 0);
    }
    return result;
  }
}

export class TrackedResponseMetric {
  entityId: number | string;
  entityType: Entities;
  resolution: Periods;
  range: { start?: moment.Moment; end?: moment.Moment } | null;
  fetchedAt: number; // unix timestamp when this metric was received from the API
  metrics: Record<string, TrackedResponseMetricStat>;

  constructor(
    entityId: number | string,
    entityType: Entities,
    resolution: Periods,
    metrics: Record<string, any>,
    range: { start?: moment.Moment; end?: moment.Moment } | null = null,
  ) {
    this.entityId = entityId;
    this.entityType = entityType;
    this.resolution = resolution;
    this.range = range ?? null;
    this.fetchedAt = Math.floor(Date.now() / 1000);
    this.metrics = {};
    for (let key in metrics) {
      this.metrics[key] = new TrackedResponseMetricStat(metrics[key].totals, metrics[key].tracked_responses);
    }
  }
}
